<template>
  <div class="px-4 pt-4">
    <div class="d-flex align-center justify-space-between">
      <v-menu offset-y :close-on-content-click="false" v-model="isShowMenu">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-on="on"
              v-bind="attrs"
              color="#5D62D1">
            Tìm kiếm
          </v-btn>
        </template>
        <div class="filter-wrapper">
          <div>
            <v-autocomplete
                v-model="filterForm.fanpageId"
                :items="fanpages"
                outlined
                multiple
                placeholder="Tìm fanpage"
                item-text="name"
                item-value="_id"
                hide-details
                clearable
            >
            </v-autocomplete>
          </div>
          <div class="mt-3">
            <v-text-field
              v-model="filterForm.masterId"
              outlined
              placeholder="Tìm master_id"
              hide-details
              clearable
            >
            </v-text-field>
          </div>
          <div class="mt-3">
            <v-text-field
                v-model="filterForm.contentId"
                outlined
                placeholder="Tìm content_id"
                hide-details
                clearable
            >
            </v-text-field>
          </div>
          <div class="mt-3">
            <v-text-field
                v-model="filterForm.adId"
                outlined
                placeholder="Tìm ad_id"
                hide-details
                clearable
            >
            </v-text-field>
          </div>
          <div class="mt-3 d-flex align-center justify-center" >
            <v-btn color="#FF8057" @click="handleFilter">
              Tìm
            </v-btn>
          </div>
        </div>
      </v-menu>
      <v-btn outlined color="#5D62D1" v-if="checkAuthorization('define-master-content_create')" @click="handleCreate">
        <v-icon color="#5D62D1">mdi-plus</v-icon>
        Tạo bộ mã
      </v-btn>
    </div>
    <div class="mt-2">
      <FacebookResponsibleTable ref="facebookResTable"></FacebookResponsibleTable>
    </div>
  </div>
</template>

<script>
import FacebookResponsibleTable
  from "@/pages/report-mkt/define-facebook-page-responsible/component/FacebookResponsibleTable";
import ReportRepository from "@/repositories/ReportRepository";
import TokenService from "@/helpers/token";
export default {
  name: "index",
  components: {
    FacebookResponsibleTable,
  },
  data() {
    return {
      isShowMenu: false,
      isShowPopup: false,
      fanpages: [],
      filterForm: {
        fanpageId: [],
        masterId: null,
        contentId:null,
        adId: null,
      },
    }
  },
  created() {
    this.getListFanpage();
  },
  methods: {
    handleCreate() {
      this.$refs.facebookResTable.handleShowPopup('create');
    },
    handleFilter() {
      this.$refs.facebookResTable.getListMasterContentId(this.filterForm);
      this.isShowMenu = false;
    },
    async getListFanpage() {
      const response = await ReportRepository.getListFanpage();
      if (response.success) {
        this.fanpages = response.data
      }
    }
  }
}
</script>

<style scoped>
.filter-wrapper {
  width: 300px;
  background: white !important;
  padding: 17px !important;
}
</style>